import { TailSpin } from 'react-loader-spinner'
import { TestItem } from '../../components/TestItem'
import { useGetShippingTestsQuery } from '../../generated/urql.anonymous'
import { Blue300 } from '../../lib/colors'
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { useI18n } from '../../provider/i18n'
import { AuthContext } from '../../provider/auth'
import { BasketContext, isShippingTestBasketItem } from '../../provider/basket'
import { useAtomValue } from 'jotai'
import { profilesSubscriptionAtom } from '../../store/subscription.atoms'
import { SearchTestFragment } from '../../generated/urql.client'
import ProfileSelectorModal, {
  ProfileSelectorModalType,
} from '../../components/ProfileSelectorModal'

const ShippingTests = () => {
  const [isInited, setIsInited] = useState(false)
  const i18n = useI18n()
  const profileSelectorModalRef = useRef<ProfileSelectorModalType>(null)
  const basket = useContext(BasketContext)
  const { isLogged } = useContext(AuthContext)
  const [{ data: profilesData }] = useAtomValue(profilesSubscriptionAtom)
  const [{ data: testsData, fetching }] = useGetShippingTestsQuery()
  const tests = testsData?.test || []

  const isFetching = useMemo(() => fetching && !isInited, [fetching, isInited])

  useEffect(() => {
    if (!isFetching) {
      setIsInited(true)
    }
  }, [isFetching])

  const onTestAddClick = useCallback(
    (test: SearchTestFragment) => {
      const profilesCount = profilesData?.client_profile.length || 0

      if (!isLogged || profilesCount === 0) {
        basket.addItem({ test, shouldShipToClient: true })
      } else if (profilesCount === 1) {
        basket.addItem({
          test,
          profile: profilesData?.client_profile[0],
          shouldShipToClient: true,
        })
      } else {
        profileSelectorModalRef.current?.show({
          onChange: (profile) => {
            basket.addItem({ test, profile, shouldShipToClient: true })
          },
          filter: (profile) =>
            !basket.items.find(
              (item) =>
                isShippingTestBasketItem(item) &&
                item.test.id === test.id &&
                item.profile?.id === profile.id
            ),
        })
      }
    },
    [isLogged, basket, profilesData?.client_profile]
  )

  if (isFetching) {
    return (
      <TailSpin
        color={Blue300}
        height={32}
        width={32}
        wrapperClass="flex justify-center p-8"
      />
    )
  }

  return (
    <div className="mb-16">
      <div className="text-blue-700 my-5 flex items-center gap-1">
        {i18n.t('screens.catalog.index.shippingTests.header')}
      </div>
      <ul className="md:mx-5 flex flex-col gap-5 mb-10">
        {tests.map((test) => (
          <li key={test.id}>
            <TestItem
              test={test}
              variant="green"
              onTestAddClick={() => onTestAddClick(test)}
              showAddButton={
                isLogged
                  ? basket.items
                      .filter(isShippingTestBasketItem)
                      .filter(({ test: { id } }) => test.id === id).length <
                    (profilesData?.client_profile.length || 0)
                  : !basket.items.find(
                      (item) =>
                        isShippingTestBasketItem(item) &&
                        test.id === item.test.id
                    )
              }
            />
          </li>
        ))}
      </ul>

      <ProfileSelectorModal ref={profileSelectorModalRef} />
    </div>
  )
}

export default ShippingTests
